import { ref, get } from "firebase/database"

import { sdk9db } from "../firebase"
import { LocalPrivateLookup, GenericStringObj, Instructor } from "../types"

export const getInstructorPrivateLookup = async () => {
  const privateLookup: LocalPrivateLookup = {}
  await get(ref(sdk9db, "instructorsPrivate")).then((privateSnaps) => {
    privateSnaps.forEach((privateSnap) => {
      if (privateSnap.key) {
        privateLookup[privateSnap.key] = privateSnap.val()
        privateLookup[privateSnap.key].fullName =
          `${privateLookup[privateSnap.key].firstName} ${privateLookup[privateSnap.key].lastName}`
      }
    })
  })
  return privateLookup
}

export const getInstructorFullNameLookup = async () => {
  const privateLookup: GenericStringObj = {}
  await get(ref(sdk9db, "instructorsFullNames")).then((privateSnaps) => {
    privateSnaps.forEach((privateSnap) => {
      if (privateSnap.key) {
        privateLookup[privateSnap.key] = privateSnap.val()
      }
    })
  })
  return privateLookup
}

export const getSingleInstructorFullName = async (instructorId: string) => {
  let instructorFullName = ""
  await get(ref(sdk9db, `instructorsFullNames/${instructorId}`)).then(
    (privateSnap) => {
      if (privateSnap.key) {
        instructorFullName = privateSnap.val()
      }
    },
  )
  return instructorFullName
}

export const isTimeLogOverlapAllowed = (instructor: Instructor) => {
  /**
   * We currently have a few instructors who teach road tests but get
   * paid by logging a full day of admin time. So we don't send their
   * road tests. However, they have road tests on the schedule, and
   * also need to add time logs to their schedule. So we need to allow
   * them to add time logs even if they have road tests.
   */
  return !!instructor.doNotSyncRoadTestHoursWithPayroll
}
